import { Directive, AfterViewInit, ElementRef } from '@angular/core';

@Directive({
  selector: '[inputAutofocus]'
})
export class InputautofocusDirective implements AfterViewInit {

  constructor(private el: ElementRef) {
  }

  ngAfterViewInit() {
    this.el.nativeElement.focus();
  }

}



// WEBPACK FOOTER //
// /home/alinu/Alin/Work/Workspace/BART-client/src/app/shared/directives/inputautofocus/inputautofocus.directive.ts